import { render, staticRenderFns } from "./BindUser.vue?vue&type=template&id=adf5abf6&scoped=true"
import script from "./BindUser.vue?vue&type=script&lang=js"
export * from "./BindUser.vue?vue&type=script&lang=js"
import style0 from "./BindUser.vue?vue&type=style&index=0&id=adf5abf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf5abf6",
  null
  
)

export default component.exports